



































import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class SelectCircleText extends Vue {
    @Prop() private userConfigColor! : string;

    select(type : string){
        this.$emit("select", type);
    }
}
